import { Box, CircularProgress } from '@mui/material';
import { Navigate, Outlet } from 'react-router-dom';

import useBaasAccount from '@/hooks/useBaasAccount';
import { PATH_DASHBOARD } from '@/routes/paths';

export default function BankingAccountGuard() {
  const {
    account,
    accountResolutionStatus,
    isLoadingAccount,
    accountUpdatedAt,
  } = useBaasAccount();
  const isResolvingAccount =
    accountResolutionStatus === 'loading' ||
    (accountResolutionStatus === undefined && isLoadingAccount && !accountUpdatedAt);

  if (isResolvingAccount) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" minHeight="40vh">
        <CircularProgress />
      </Box>
    );
  }

  if (account?.proposal_status !== 'account_created') {
    return <Navigate to={PATH_DASHBOARD.general.financialBankingAccount} replace />;
  }

  return <Outlet />;
}
